var map = {
	"./geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-1.jpg": "90c1",
	"./geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-2.jpg": "c4f4",
	"./geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-doopsuiker-3.jpg": "e3c9",
	"./geboortekaart-op-maat-Matteo-jongen-koperfolie-foliedruk-digitaal-drukwerk-thumbnail.png": "e028"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e64a";